import React from "react";
import { useTranslation } from "react-i18next";
import {
    CustomTable,
} from "extranet-component-library";


interface CustomProps {
    travels: Array<any>;
}

const NextPrices = ({ travels }: CustomProps) => {
    const { t } = useTranslation();

    return (
        <div className="nt-table">
            <div className="title">{t("my_next_price")}</div>
            {travels && travels.length ? (
                <CustomTable
                    items={travels}
                    headers={[
                        { id: "hops", label: t("your_next_travel") },
                        { id: "price", label: t("your_price") },
                    ]}
                />
            ) : (
                <div data-testid="no-travels" className="no-items">
                    {t("no_items")}
                </div>
            )}
        </div>
    );
};

export default NextPrices;
